import { addMonths, addYears, isAfter, isBefore, parseISO, startOfDay, subDays } from 'date-fns';

export function verificationDateChecks(determinationDate: string, printsExpirationDate: string) {
    const today = startOfDay(new Date());
    const determinationDateInFuture = !!determinationDate && isAfter(startOfDay(parseISO(determinationDate)), today);
    const determinationDateIsRecent =
        !!determinationDate &&
        !determinationDateInFuture &&
        isAfter(startOfDay(parseISO(determinationDate)), subDays(today, 15));
    const printsExpirationDateInPast =
        !!printsExpirationDate && isBefore(startOfDay(parseISO(printsExpirationDate)), today);
    const printsExpiringSoon =
        !!printsExpirationDate &&
        !printsExpirationDateInPast &&
        isBefore(startOfDay(parseISO(printsExpirationDate)), addMonths(today, 1));
    const datesWithinAYear =
        !!determinationDate &&
        !!printsExpirationDate &&
        isBefore(startOfDay(parseISO(printsExpirationDate)), addYears(startOfDay(parseISO(determinationDate)), 1));
    return {
        today,
        determinationDateInFuture,
        determinationDateIsRecent,
        printsExpirationDateInPast,
        printsExpiringSoon,
        datesWithinAYear,
    };
}
